var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 4.66667L6.70833 7.20833L8.375 5.54167L11.3333 8.47917V7.16667H13V11.3333H8.83333V9.66667H10.1458L8.375 7.89583L6.70833 9.5625L3 5.83333L4.16667 4.66667ZM2.16667 0.5C1.70833 0.5 1.31597 0.663195 0.989583 0.989583C0.663194 1.31597 0.5 1.70833 0.5 2.16667V13.8333C0.5 14.2917 0.663194 14.684 0.989583 15.0104C1.31597 15.3368 1.70833 15.5 2.16667 15.5H13.8333C14.2917 15.5 14.684 15.3368 15.0104 15.0104C15.3368 14.684 15.5 14.2917 15.5 13.8333V2.16667C15.5 1.70833 15.3368 1.31597 15.0104 0.989583C14.684 0.663195 14.2917 0.5 13.8333 0.5H2.16667Z",
    fill: "#1AA527"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrow);
export default __webpack_public_path__ + "static/media/GreenArrow.c0f67fa34e7967d0245ddf81bf5375d4.svg";
export { ForwardRef as ReactComponent };